const SIZES = {
  SHARE_MODAL: {
    height: '450px',
    width: '650px',
  },
};

export default SIZES;
